module.exports = __webpack_public_path__ + "img/banner-07e.5c8e9eff.png";